import React from 'react';
import PropTypes from 'prop-types';

// 角标组件
const CornerMarker = (props) => {
  const { visable, style, className, data } = props;

  return (
    <React.Fragment>
      {visable && (
        <div className={className} style={style}>
          <span className="ellipsis-one">{data}</span>
        </div>
      )}
    </React.Fragment>
  );
};

// 默认props入参
CornerMarker.defaultProps = {
  visable: false, // 控制显示(必传)
  data: '', // 角标内容(必传)
  style: {}, // 自定义样式(可选)
  className: '' // 自定义类名(可选)
};

// 默认props类型检查
CornerMarker.PropTypes = {
  visable: PropTypes.bool.isRequired,
  data: PropTypes.string.isRequired,
  style: PropTypes.object,
  className: PropTypes.string
};

export default CornerMarker;



// WEBPACK FOOTER //
// ./src/pubBiz/CornerMarker/index.js